<div class="sidebar" [class.sidebar--open]="isSidebarOpen()">
  <div
    class="sidebar__meta"
    [class.sidebar__meta--aligned]="isSidebarOpen()"
    (click)="sidebarClosed.emit()">
    <img
      class="sidebar__logo"
      [class.sidebar__logo--full]="isSidebarOpen()"
      [class.sidebar__logo--small]="!isSidebarOpen()"
      [src]="
        isSidebarOpen()
          ? 'assets/images/logo.png'
          : 'assets/images/logo-small.png'
      "
      alt="logo" />
  </div>

  <div class="sidebar__menu">
    @for (config of sidebarButtonConfig; track $index) {
      <button
        pButton
        pRipple
        class="sidebar__item"
        routerLinkActive="action"
        [routerLinkActiveOptions]="{
          paths: 'exact',
          queryParams: 'ignored',
          matrixParams: 'ignored',
          fragment: 'ignored',
        }"
        [routerLink]="config.routerLink"
        [queryParams]="config.queryParams"
        [pTooltip]="!isSidebarOpen() ? config.label : ''">
        <i class="sidebar__icon" [class]="config.iconName"></i>
        @if (isSidebarOpen()) {
          <span>{{ config.label }}</span>
        }
      </button>
    }
  </div>

  <button
    pButton
    pRipple
    class="sidebar__logout"
    (click)="logoutClicked.emit()"
    [loading]="isLogoutLoading()">
    @if (!isLogoutLoading()) {
      <i class="sidebar__icon pi pi-sign-out"></i>
    }
    @if (isSidebarOpen()) {
      <span>Logout</span>
    }
  </button>
</div>
